export default function AboutSection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1">
            <span className="inline-block px-3 py-1 mb-4 text-xs font-semibold tracking-wider uppercase text-primary-700 bg-primary-100/70 rounded-full">
              About the Platform
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-5">
              What Is Basetao Spreadsheet?
            </h2>
            <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              <p>
                <strong className="text-foreground-900">Basetao Spreadsheet</strong> is a curated product research system designed to help shoppers discover trending products, compare options, understand quality information, and make smarter purchasing decisions on the Basetao platform.
              </p>
              <p>
                Instead of manually searching through thousands of products, users can access organized information, expert recommendations, and practical buying guides — all structured in an easy-to-navigate spreadsheet format. Whether you are looking for the latest sneakers, streetwear essentials, luxury accessories, or seasonal fashion pieces, the Basetao Spreadsheet helps you find what you need faster and with greater confidence.
              </p>
              <p>
                Our platform bridges the gap between casual browsing and informed purchasing. Every product category is carefully researched and updated regularly to reflect the most current trends and best-value finds available through Basetao.
              </p>
            </div>
            <div className="flex flex-wrap gap-3 mt-6">
              <span className="px-3 py-1.5 text-xs font-medium text-foreground-600 bg-background-200/70 rounded-full whitespace-nowrap">Trending Products</span>
              <span className="px-3 py-1.5 text-xs font-medium text-foreground-600 bg-background-200/70 rounded-full whitespace-nowrap">Price Comparison</span>
              <span className="px-3 py-1.5 text-xs font-medium text-foreground-600 bg-background-200/70 rounded-full whitespace-nowrap">Expert Reviews</span>
              <span className="px-3 py-1.5 text-xs font-medium text-foreground-600 bg-background-200/70 rounded-full whitespace-nowrap">Shipping Guides</span>
            </div>
          </div>

          <div className="flex-1 w-full">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/3] bg-background-200">
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20laptop%20displaying%20colorful%20spreadsheet%20dashboard%20with%20product%20data%20charts%20and%20fashion%20item%20thumbnails%20on%20sleek%20dark%20wooden%20desk%20with%20coffee%20cup%20and%20notebook%20nearby%20bright%20airy%20office%20with%20floor%20to%20ceiling%20windows%20green%20plants%20natural%20daylight%20productive%20creative%20workspace&width=800&height=600&seq=about-v2&orientation=landscape')`,
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}